// extracted by mini-css-extract-plugin
export var divider = "_2u-0";
export var dividerText = "_2u-1";